<div class="upload-group">
  <h2 mat-dialog-title>Upload Time Table Schedule</h2>
  <mat-dialog-content class="dialog-content">
    <form
      [formGroup]="form"
      fxLayout="column"
      (ngSubmit)="upload()"
      id="timetable-upload-form">
      <mat-form-field
        appearance="outline"
        class="form-field"
        subscriptSizing="dynamic"
        hideRequiredMarker>
        <mat-label>Select Route</mat-label>
        <mat-select
          formControlName="routeId"
          #routeSelect
          (valueChange)="getRouteLadder($event)">
          <mat-option *ngFor="let route of routeList" [value]="route">
            {{ route }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('routeId').hasError('failed')">
          Failed to load route. Please select the route and try again.
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="directions.length > 0"
        appearance="outline"
        class="form-field"
        subscriptSizing="dynamic"
        hideRequiredMarker>
        <mat-label>Direction</mat-label>
        <mat-select
          formControlName="tripDirection"
          (valueChange)="getRoutePattern($event)">
          <mat-option *ngFor="let direction of directions" [value]="direction">
            {{ direction }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="form.controls.tripDirection.hasError('directionError')"
          >{{ directionError }}</mat-error
        >
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        hideRequiredMarker
        class="form-field"
        [ngClass]="{ 'read-only': true }"
        [hidden]="true"
        subscriptSizing="dynamic">
        <mat-label>Route Pattern Version</mat-label>
        <input
          matInput
          formControlName="routePattern"
          readonly
          placeholder="Route Pattern Version" />
      </mat-form-field>
      <!-- [hidden]="!form.controls.routePattern.value" -->

      <mat-form-field
        appearance="outline"
        hideRequiredMarker
        class="form-field"
        [hidden]="true"
        subscriptSizing="dynamic">
        <mat-label>Upload CSV</mat-label>
        <input
          matInput
          formControlName="routePattern"
          readonly
          placeholder="Route Pattern Version" />
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-field"
        subscriptSizing="dynamic"
        [hidden]="!routeSuccess"
        (mousedown)="picker.open(); $event.preventDefault()"
        hideRequiredMarker>
        <mat-label>Date Range</mat-label>
        <mat-date-range-input
          [formGroup]="form"
          [rangePicker]="picker"
          [min]="minDate">
          <input
            matStartDate
            readonly
            formControlName="startTripDate"
            placeholder="Start date" />
          <input
            matEndDate
            readonly
            formControlName="endTripDate"
            placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error
          *ngIf="form.controls.startTripDate.hasError('matStartDateInvalid')"
          >Invalid start date</mat-error
        >

        <mat-error
          *ngIf="form.controls.endTripDate.hasError('matEndDateInvalid')"
          >Invalid end date</mat-error
        >
      </mat-form-field>
      <button
        mat-stroked-button
        class="form-button"
        *ngIf="directions.length > 0"
        [disabled]="
          !form.get('tripDirection').value || form.get('tripDirection').invalid
        "
        (click)="generateTemplate()"
        type="button">
        Download CSV template
      </button>
      <div class="form-container" *ngIf="directions.length > 0">
        <app-common-file-upload
          formControlName="file"
          accept="text/csv"
          [hasMargin]="true"></app-common-file-upload>
        <span *ngIf="hasError('file', 'required')" class="form-error"
          >This field is required</span
        >
        <span *ngIf="hasError('file', 'requiredFileType')" class="form-error"
          >Only CSV files are allowed</span
        >
        <span *ngIf="hasError('file', 'contentError')" class="form-error">{{
          fileError
        }}</span>
      </div>
      <!-- <input hidden formControlName="routePattern" /> -->
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close [disabled]="loading">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      form="timetable-upload-form"
      [disabled]="loading || !form.valid">
      Upload
      <!-- [disabled]="loading || !form.valid" -->
    </button>
  </mat-dialog-actions>
  <div class="content-loading" *ngIf="loading">
    <mat-spinner class="margin-auto"></mat-spinner>
  </div>
</div>
